import React from "react";
import "./lesson-information-header.scss";
import LessonTypeBadge from "../lesson-type-badge/lesson-type-badge";

interface ILessonTitleProps {
  title: string;
  lessonType: string;
  isPracticeEnabled: boolean;
}
const LessonInformationHeader = (props: ILessonTitleProps) => {
  const { title, lessonType, isPracticeEnabled } = props;

  return (
    <div className="lesson-information-header">
      <span className="lesson-title">{title}</span>
      {isPracticeEnabled && <LessonTypeBadge lessonType={lessonType} />}
    </div>
  );
};
export default LessonInformationHeader;
